var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhyRbIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.066,
    height: 17.224,
    viewBox: "0 0 27.066 17.224",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "why-icon-1",
    d: "M19.954,14.882a3.691,3.691,0,1,0-3.691-3.691A3.675,3.675,0,0,0,19.954,14.882Zm-9.842,0a3.691,3.691,0,1,0-3.691-3.691A3.675,3.675,0,0,0,10.112,14.882Zm0,2.461c-2.867,0-8.612,1.439-8.612,4.306v3.076H18.724V21.648C18.724,18.782,12.978,17.342,10.112,17.342Zm9.842,0c-.357,0-.763.025-1.193.062a5.192,5.192,0,0,1,2.424,4.244v3.076h7.382V21.648C28.566,18.782,22.821,17.342,19.954,17.342Z",
    transform: "translate(-1.5 -7.5)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyRbIcon1);
export default __webpack_public_path__ + "static/media/why-rb-icon-1.aab906250dce6700ea7e22e7ffde82cb.svg";
export { ForwardRef as ReactComponent };